import React, {Component} from 'react';

export class Livebackground extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: parseInt(props.startTimeInSeconds, 500) || 0
    };
  }
  bgStyle = {
    color: 'blue',
    bg: "https://www.glerl.noaa.gov/metdata/mkg/mkg01.jpg#",
  };
  componentDidMount() {
    // setInterval(() => {
    //   this.setState(() => {
    //     //console.log('setting state');
    //     return {unseen: "does not display"}
    //   });
    // }, 1000);
  }

  render() {
    return (
      <div className="backgroundImage" style={this.bgStyle}></div>
    )
  }
}

export default Livebackground;